/**
 * Explicit KPI override. Unchecked / incomplete pair means tenant default.
 */

import React from 'react';
import { KpiThresholdFields, type ThresholdDraft } from './KpiThresholdFields';

interface KpiThresholdOverrideProps {
  enabled: boolean;
  draft: ThresholdDraft;
  onEnabled: (enabled: boolean) => void;
  onChange: (next: ThresholdDraft) => void;
  t: (key: string) => string;
}

export const KpiThresholdOverride: React.FC<KpiThresholdOverrideProps> = ({
  enabled,
  draft,
  onEnabled,
  onChange,
  t
}) => (
  <div className="mb-3">
    <label className="flex items-start gap-1.5 text-[11px] text-[var(--color-surface-text)] mb-1">
      <input
        type="checkbox"
        className="mt-0.5"
        checked={enabled}
        onChange={(event) => onEnabled(event.target.checked)}
      />
      <span>
        {t('kpi.thresholdOverride') || 'Use custom bands for this KPI'}
        <span className="block text-[10px] text-[var(--color-secondary-text)] leading-tight">
          {t('kpi.thresholdOverrideHint') ||
            'Leave off to use the tenant defaults. Both numbers are required for an override.'}
        </span>
      </span>
    </label>
    {enabled && <KpiThresholdFields draft={draft} onChange={onChange} t={t} />}
  </div>
);
